<template>
    <div class="sideMenu">
        <div class="logoWrap">
            <img v-if="$store.state.app.domain" class="logo" v-bind:src="$store.state.app.logo !== '' ? `https://${$store.state.app.domain}/logos/${$store.state.app.logo}` : '/static/images/logo.png'" alt="">
        </div>
        <ul class="menuWrap">

            <li v-bind:class="router.currentRoute.name!=null && router.currentRoute.name.includes((Object.keys(menu)[0] == 'hp' ? 'dashboard' : Object.keys(menu)[0])) ? 'active' : ''" v-for="menu in $store.state.user.menus" v-if="(Object.keys(menu)[0] == 'sms' ? ($store.state.event.hasSms) : true)">
                <router-link v-if="Object.keys(menu)[0] != 'reports'" v-bind:to="(Object.keys(menu)[0] == 'hp' ? '/' : '/' + ((Object.keys(menu)[0] == 'guests' || Object.keys(menu)[0] == 'seating') ? (Object.keys(menu)[0] + '/' + $store.state.event.id) : Object.keys(menu)[0]))">
                    <svg v-bind:class="'menuIcon ' + getMenuIcon(Object.keys(menu)[0])"><use v-bind:xlink:href="getMenuIcon(Object.keys(menu)[0],true)"></use></svg>
                    <span>{{ (Object.keys(menu)[0] == 'users' ? $t('menu_usersFor_' + $store.state.user.type) : $t('menu_'+Object.keys(menu)[0])) }}</span>
                </router-link>
            </li>

        </ul>

        <!--<a href="#" @click.prevent="openReportsModal" class="reports" v-if="this.$store.state.user.type == 3">
            <svg class="i_reports"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#i_download"></use></svg>
            <span>{{ $t('menu_reports') }}</span>
        </a>-->
    </div>
</template>

<script>
    export default {
        name: 'SideMenu',
        data() {
            return{
                router:this.$router
            }
        },
        beforeMount(){
        },
        methods:{

            getMenuIcon(menu,hashtag){
                let icon = '';
                switch(menu){
                    case 'hp':
                        icon = 'home';
                        break;
                    case 'settings':
                    case 'sms':
                        icon = 'settings';
                        break;
                    case 'users':
                    case 'guests':
                        icon = 'users';
                        break;
                    case 'calendar':
                        icon = 'calender';
                        break;
                    case 'seating':
                        icon = "seating";
                        break;
                    case 'screen':
                        icon = 'template';
                        break;
                    case 'reports':
                        icon = "i_download";
                        break;
                    default:
                        icon = 'home';
                        break;
                }
                return (hashtag ? '#' : '')+'i_'+icon;
            },

            usersTitle(){
                return this.$t('menu_usersFor_' + this.$store.state.user.type)
            },

            openReportsModal(){
                $("#modal-reports").iziModal({
                    autoOpen: 1,
                });
            }
        }
    }

</script>
<style scoped>
    .menuIcon{
        height: 28px;
    }
</style>
